import React, {Component} from 'react';
import {Col, Container, Row} from "react-bootstrap";
class Footer extends Component {
    render() {
        return (
            <Container fluid={true}>
                <Row className="shadow-sm p-2 bg-light fixed-bottom text-center">
                    <Col className="text-center mt-1">
                        <p className="m-1 p-0">All Rights Reserved © 2021-2022</p>
                    </Col>
                </Row>
            </Container>
        );
    }
}
export default Footer;